/**
 * Get location for contact form
 *
 * @example
 * initWPCF7Location();
 *
 * @returns {void}
 */
const initWPCF7Location = () => {

    $('.wpcf7-form').append("<input type='hidden' name='page' value='" + window.location.href + "'/>");

    $.ajax({
        url: ajaxurl,
        type: 'post',
        dataType: 'json',
        data: {
            'action' : 'get_location',
        },
        beforeSend: () => {
        },
        success: (response) => {
            //console.log(response);

            if(response.country) {
                $('.wpcf7-form').append("<input type='hidden' name='country' value='" + response.country + "'/>");
            }

            if(response.city) {
                $('.wpcf7-form').append("<input type='hidden' name='city' value='" + response.city + "'/>");
            }
        },
        complete: function () {
        }
    })
};

initWPCF7Location();
